<template>
  <div class="left-box">
    <div class="left-title d-aligncnter d-between">
      <div class="d-aligncnter">
        <img
          class="img-24"
          src="@/assets/img/cockpit/school.svg"
          style="width: 24px; height: 24px; margin-right: 8px"
        />
        各学院学期考勤情况
      </div>
      <div class="select-option">
        <el-select v-model="currTerm" placeholder="请选择" @change="changeTermData">
          <el-option v-for="item in termList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </div>
    </div>
    <table class="left-table" cellspacing="0">
      <tr class="t-head">
        <!-- <td class="td-1">序号</td> -->
        <td class="td-2">学院</td>
        <td class="td-3">签到</td>
        <td class="td-3">迟到</td>
        <td class="td-4">请假</td>
        <td class="td-4">旷课</td>
        <td class="td-4">到课率</td>
      </tr>
    </table>
    <div style="height: 100%; overflow: hidden" @mouseenter="stopScroll" @mouseleave="startScroll">
      <table class="left-table" cellspacing="0" :class="{ 'animated-top': animatedTop && this.attendData.length > 10 }">
        <tr
          class="tr-data"
          :class="{
            'color-tr': getBgClass(index),
            'mt-20': index == attendData.length - 1,
          }"
          v-for="(item, index) in attendData"
          :key="'run_' + index"
        >
          <!-- <td class="td-1">{{ item.code }}</td> -->
          <td class="college-name td-2 overflow">
            {{ item.collegeName }}
          </td>
          <td class="td-3">{{ item.qd }}</td>
          <td class="td-3">{{ item.cd }}</td>
          <td class="td-4">{{ item.qj }}</td>
          <td class="td-4">{{ item.kk }}</td>
          <td class="td-4">
            <span style="margin-right: 8px"> {{ (item.attendanceRate * 100).toFixed(2) }}% </span>

            <span v-if="item.up == null">-</span>
            <span v-else-if="item.up">↑</span>
            <span v-else>↓</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ['TermSigninData', 'termList'],
  data() {
    return {
      attendData: [],
      animatedTop: false,
      timer: null,
      flag: true,
      modeData: 0,
      currTerm: '',
    }
  },
  watch: {
    TermSigninData: {
      handler: function () {
        this.attendData = this.TermSigninData
        this.stopScroll()
        this.startScroll()
      },
      deep: true,
    },

    termList: {
      handler: function () {
        this.currTerm = this.termList[0].id
      },
      deep: true,
    },
  },
  created() {
    this.attendData = this.TermSigninData
    this.currTerm = this.termList[0].id
    // if (this.dayCollegeData.length > 10) {
    //   this.runData = [...this.dayCollegeData, ...this.dayCollegeData]
    // } else {
    //   this.runData = this.dayCollegeData
    // }
  },
  mounted() {
    this.timer = setInterval(() => {
      //   console.log('runData:', this.attendData)
      if (this.attendData.length > 10) {
        this.animatedTop = true
        setTimeout(() => {
          this.attendData.push(this.attendData[0])
          this.attendData.shift()
          this.animatedTop = false
        }, 500)
      } else {
        this.stopScroll()
      }
    }, 2000)
  },
  computed: {
    getBgClass() {
      return function (index) {
        if (index % 2 == this.modeData) {
          return false
        }
        return true
      }
    },
  },
  methods: {
    stopScroll() {
      console.log('22')
      clearInterval(this.timer)
      this.timer = null
    },
    startScroll() {
      console.log('11')
      this.timer = setInterval(() => {
        if (this.attendData.length > 10) {
          this.animatedTop = true
          setTimeout(() => {
            this.attendData.push(this.attendData[0])
            this.attendData.shift()
            this.animatedTop = false
          }, 500)
        } else {
          this.stopScroll()
        }
      }, 2000)
    },
    changeTermData(e) {
      console.log('changeTermData:', e)
      this.$emit('changeTerm', e, 'left')
    },
  },
}
</script>
<style scoped lang="scss">
.animated-top {
  transition: all 0.5s;
  margin-top: -36px;
}
.left-box {
  //   width: calc(100% - 48px);
  //   margin-left: 24px;
  .left-title {
    font-size: 22px;
    margin-bottom: 8px;
  }
  .left-table {
    width: calc(100% - 0px);
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    border-radius: 4px;
  }
}
table {
  table-layout: fixed;
  width: 100%;
  tr td {
    text-align: center;
    height: 36px;
    // height: 3vh;
  }
  .t-head {
    width: 100%;
    background: linear-gradient(0deg, rgba(6, 88, 58, 0.0884779) -24.83%, #06583a 100%);
    height: 36px;
    // height: 4vh;
  }
  tr {
    width: 100%;
    .td-1 {
      width: 16%;
    }
    .td-2 {
      width: 16%;
    }
    .td-3,
    .td-4 {
      width: 16%;
    }
  }
  .color-tr {
    background: rgba(0, 122, 77, 0.2);
  }
  //   .tr-data {
  //     .college-name {
  //       text-align: left;
  //     }
  //   }
}
.mt-20 {
  margin-bottom: 20px;
}
.left-box {
  height: 99%;
  overflow: hidden;
}
.select-option ::v-deep .el-input__inner,
.el-select-dropdown__item.is-disabled:hover {
  background-color: rgba(255, 255, 255, 0) !important;
}
.select-option ::v-deep .el-input__inner {
  //   border: 1px solid #007a4d !important;
  height: 36px;
  color: #fff;
  width: 205px;
  border: none;
  text-align: right;
  //   padding-right: 16px !important;
}
.select-option ::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 105px;
}
.select-option ::v-deep .el-input__icon {
  line-height: 36px;
}
</style>
